/**
 * Cross-module insured-profile store — holds the GET /insured/session
 * payload (insured id, email, abbreviation, …). Pages read this to
 * decide `isAuthenticated`; the auth + dashboard + profile + quote flows
 * all reach for the same source of truth.
 */
class InsuredProfileStore {
  #listeners = new Set();
  #insuredProfile = null;

  get insuredProfile() { return this.#insuredProfile; }
  set insuredProfile(dto) {
    this.#insuredProfile = dto || null;
    this.#notify();
  }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#insuredProfile = null;
    this.#notify();
  }
}

const insuredProfileStore = new InsuredProfileStore();
export default insuredProfileStore;
